import { render, staticRenderFns } from "./SelectTemplateSettings.vue?vue&type=template&id=1270ed05&scoped=true&"
import script from "./SelectTemplateSettings.vue?vue&type=script&lang=js&"
export * from "./SelectTemplateSettings.vue?vue&type=script&lang=js&"
import style0 from "./SelectTemplateSettings.vue?vue&type=style&index=0&id=1270ed05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270ed05",
  null
  
)

export default component.exports